import { allPageTypes } from "global/enums/allPageTypes"
import { gEnums } from "global/enums/globalEnums"
import { useContext, useMemo } from "react"
import { ParentContext } from "../ParentContext"
import { getThemeColorDirect } from "global/styles/formatting"

export const useAllowAppUser = ({ gcProps, allows }) => {

  const pageIcons = null

  const parentContext = useContext(ParentContext)
  const { states } = parentContext ?? {}
  const { paps_state, appUser_state, appNotifications_state, currentSettings_state, survey_state, questionsAndAnswers_state } = states ?? {}

  const { pathViews } = paps_state ?? {}
  const { appUser } = appUser_state ?? {}
  const { appUserAccess } = appUser ?? {}
  const { isSuperAdminDeveloper } = appUserAccess ?? {}
  const { appUserAccessType, appUserSessionKey, events: events_appUser } = appUserAccess ?? {}
  const currentAppUserEvent = events_appUser && pathViews.events ? events_appUser[pathViews.events] : null
  const { appUserKey } = currentAppUserEvent ? currentAppUserEvent : {}
  const _appUserSessionKey = appUserKey ? appUserKey : appUserSessionKey

  // pageContext  
  const { aps_global, aps_appUserSettings } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appMeetings, appNotifications, appSurvey, appVoting, appQuestionsAndAnswers } = aps_global ?? {}
  const { allowNotifications, showNotificationsOnHomeScreen, notificationsHomeScreenCaption, showNotificationsCount, notificationLabelColor } = appNotifications ?? {}
  const { allowChat, showChatOnHomeScreen, allowNotes, showNotesOnHomeScreen, showFavoritesOnHomeScreen } = aps_appUserSettings ?? {}
  const { allowVoting, showVotingOnHomeScreen, votingHomeScreenCaption } = appVoting ?? {}
  const { allowSurvey, surveyIsActive: surveyIsActive_global, surveyHomeScreenCaption, surveyUrl } = appSurvey ? appSurvey : {}
  const { allowMeetings, showMeetingsManagerOnHomeScreen, appAdminOnly } = appMeetings ?? {}
  const { allowQuestionsAndAnswers, showOnLandingPage, landingPageLocation, qAndACaption } = appQuestionsAndAnswers ?? {}

  const { notifications_appUser } = appNotifications_state ?? {}
  const { unread: notificatiions_unread, hasNew } = notifications_appUser ?? {}

  const { questionsAndAnswersActive } = questionsAndAnswers_state ?? {}

  // surveyContext  
  const { activeSurvey } = survey_state ?? {}
  const { surveyIsActive } = activeSurvey ?? {}

  const _surveyIsActive = surveyIsActive_global || surveyIsActive

  let _allowSurvey;

  let allow = !pageIcons && allowSurvey && _surveyIsActive && surveyUrl
  if (allow && allows.asr) { _allowSurvey = true }

  let _allowMeetings;
  let allowMtg = !pageIcons && allowMeetings && showMeetingsManagerOnHomeScreen
  if (allowMtg && allows.asr && !appAdminOnly) { _allowMeetings = true }

  let _allowQandA;
  let allowQandA = !pageIcons && questionsAndAnswersActive && questionsAndAnswersActive.length > 0
  _allowQandA = allowQuestionsAndAnswers && showOnLandingPage && allowQandA && landingPageLocation === gEnums.landingPageLocations.appUser

  const notificationProps = {
    text: showNotificationsCount && hasNew && notificatiions_unread && notificatiions_unread.length > 0 ? notificatiions_unread.length : null,
    color: notificationLabelColor ? getThemeColorDirect(aps_global, notificationLabelColor) : null
  }

  const allowedItem = (viewItem, segProps, gcProps, hidden) => {
    const { key } = viewItem ?? {}
    return { viewItem, itemKey: key, segProps, gcProps, hidden }
  }

  const favoritesGridItem = (items) => {
    const giProps = {
      caption: 'Favorites',
      icon: 'star outline',
    }
    items.push(allowedItem({ key: 'favorites', itemKey: _appUserSessionKey }, giProps, gcProps))
  }

  const items = useMemo(() => {
    const _items = []
    if (!pageIcons) {
      if (allowNotifications && showNotificationsOnHomeScreen) { _items.push(allowedItem({ key: allPageTypes.notifications }, { caption: notificationsHomeScreenCaption ? notificationsHomeScreenCaption : 'Your Notifications', icon: 'alarm', notification: notificationProps.text ? notificationProps : null }, gcProps)) }
      if (allowChat && showChatOnHomeScreen) { _items.push(allowedItem({ key: allPageTypes.chat }, { caption: 'Chat', icon: 'conversation', }, gcProps)) }
      if (showFavoritesOnHomeScreen) { favoritesGridItem(_items) }
      if (_allowMeetings) { _items.push(allowedItem({ key: allPageTypes.meetingsManager }, { caption: 'Meetings', icon: 'clipboard check', cn: 'ao' }, gcProps)) }
      if (allowNotes && showNotesOnHomeScreen) { _items.push(allowedItem({ key: allPageTypes.notes }, { caption: 'Notes', icon: 'edit outline' }, gcProps)) }
      if (_allowQandA) { _items.push(allowedItem({ key: allPageTypes.qAndA }, { caption: qAndACaption ? qAndACaption : 'Q&A', icon: 'question circle' }, gcProps)) }
      if (_allowSurvey) { _items.push(allowedItem({ key: allPageTypes.survey }, { caption: surveyHomeScreenCaption ? surveyHomeScreenCaption : 'Survey', icon: 'list ol' }, gcProps)) }
      if (allowVoting && showVotingOnHomeScreen) { _items.push(allowedItem({ key: allPageTypes.voting }, { caption: votingHomeScreenCaption ? votingHomeScreenCaption : 'Voting', icon: 'check circle outline' }, gcProps)) }
    }
    return _items
  }, [
    allowNotifications,
    showNotificationsOnHomeScreen,
    allowChat,
    showChatOnHomeScreen,
    showFavoritesOnHomeScreen,
    _allowMeetings,
    allowNotes,
    showNotesOnHomeScreen,
    _allowQandA,
    _allowSurvey,
    allowVoting,
    showVotingOnHomeScreen
  ])



  return items

}